import http from '@/uteis/http'
import { atribuir } from '@/uteis/action/atribuir'
import { desatribuir } from '@/uteis/action/desatribuir'
import { receber } from '@/uteis/action/receber'
import { volume } from '@/uteis/action/volume'
import { getSolicitante } from '@/uteis/action/solicitante'
import { arquivar } from '@/uteis/action/arquivar'
import { desarquivar } from '@/uteis/action/desarquivar'
import { eliminar } from '@/uteis/action/eliminar'
import { desfazer } from '@/uteis/action/desfazer'
import { criarInstanciador } from '@/uteis/action/atribuir/instanciador'
import { resgatarProtocolo } from '@/uteis/action/tramite'
import { criarFinalizador } from '@/uteis/action/tramite/finalizador'

const _usuarioNaoAutorizado = (err) =>
  err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!'

export default class VirtusService {
  async getNumeroLote (dadosSessao) {
    var solicitante = getSolicitante(dadosSessao)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados/lote', { ...solicitante }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados/lote', { ...solicitante }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async criarAcesso (values) {
    var url = `/d0593/pae-back/v1/protocolos/${values.numeroProcesso}/documentos/acesso`
    return new Promise((resolve, reject) => {
      http.post(url, values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async getNumeroProtocoloDocumento () {
    var url = '/d0593/pae-back/v1/protocolos/documento/protocolo'
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async criarDocumento (values) {
    var url = '/d0593/pae-back/v1/protocolos/documentos'
    return new Promise((resolve, reject) => {
      http.post(url, values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultarProcessosElaboracao (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/protocolos/setor', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/protocolos/setor', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultarProcessosAReceber (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultarProcessosTramitados (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultarNoSetor (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultaMeus (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/tramitados/identificador', { params: filtro }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async arquivarProtocolo (values, dadosSessao) {
    var dados = arquivar(values, dadosSessao)
    var url = '/d0593/pae-back/v1/protocolos/arquivamentos'
    return new Promise((resolve, reject) => {
      http.post(url, dados).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, dados).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async eliminarProtocolo (values, dadosSessao) {
    var dados = eliminar(values, dadosSessao)
    var url = '/d0593/pae-back/v1/protocolos/eliminacao'
    return new Promise((resolve, reject) => {
      http.post(url, dados).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, dados).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async editarEliminacaoProtocolo (values, dadosSessao) {
    var dados = eliminar(values, dadosSessao)
    var url = '/d0593/pae-back/v1/protocolos/eliminacao'
    return new Promise((resolve, reject) => {
      http.put(url, dados).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.put(url, dados).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desfazerEliminacaoProtocolo (values, dadosSessao) {
    var dados = desfazer(values, dadosSessao)
    var url = '/d0593/pae-back/v1/protocolos/eliminacao/desfazer'
    return new Promise((resolve, reject) => {
      http.put(url, dados).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.put(url, dados).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desarquivarProtocolo (values, dadosSessao) {
    var dados = desarquivar(values, dadosSessao)
    var url = '/d0593/pae-back/v1/protocolos/arquivamentos/desarquivar'
    return new Promise((resolve, reject) => {
      http.put(url, dados).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.put(url, dados).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async editarArquivamento (values) {
    var url = '/d0593/pae-back/v1/protocolos/arquivamentos'
    return new Promise((resolve, reject) => {
      http.put(url, values).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.put(url, values).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async apensar (value) {
    var url = `/d0593/pae-back/v1/protocolos/${value.processo}/apensacoes`
    return new Promise((resolve, reject) => {
      http.post(url, value).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, value).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultaApensacoes (processo, filtro) {
    var url = `/d0593/pae-back/v1/protocolos/${processo}/apensacoes`
    return new Promise((resolve, reject) => {
      http.get(url, { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desapensacoes (value) {
    var url = `/d0593/pae-back/v1/protocolos/${value.processo}/apensacoes/${value.processoDesapensado}`
    return new Promise((resolve, reject) => {
      http.post(url, value).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, value).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async anexar (value) {
    var url = `/d0593/pae-back/v1/tramitados/${value.processo}/anexacoes`
    return new Promise((resolve, reject) => {
      http.post(url, value).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, value).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultaAnexacoes (processo, filtro) {
    var url = `/d0593/pae-back/v1/tramitados/${processo}/anexacoes`
    return new Promise((resolve, reject) => {
      http.get(url, { params: filtro }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desanexacao (value) {
    var url = `/d0593/pae-back/v1/tramitados/${value.processo}/anexacoes/${value.processoDesanexado}`
    return new Promise((resolve, reject) => {
      http.post(url, value).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, value).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async receberProcessos (processo, dadosSessao) {
    var dados = receber(processo, dadosSessao)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados/receber', { ...dados }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados/receber', { ...dados }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async registrarHistorico (sessao, numeroProcesso, descricao = '') {
    const dadosDoHistorico = this._montarDadosParaOHistorico(sessao, numeroProcesso, descricao)
    return this.registrarNoHistorico(dadosDoHistorico)
  }

  async registrarAtribuicaoNoHistorico (dadosDaSessaoDoUsuarioAtribuidor, dadosDaSessaoDoUsuarioAtribuido, numeroProcesso) {
    const descricao = this._criarDescricaoDoUsuarioAtribuido(dadosDaSessaoDoUsuarioAtribuido.nomeUsuario, numeroProcesso)
    const dadosDoHistorico = this._montarDadosParaOHistorico(dadosDaSessaoDoUsuarioAtribuidor, numeroProcesso, descricao)
    return this.registrarNoHistorico(dadosDoHistorico)
  }

  async registrarDesatribuicaoNoHistorico (usuarioAtribuidor, processo) {
    const descricao = this._criarDescricaoParaDesatribuicao(usuarioAtribuidor, processo)
    const dadosParaOHistorico = this._montarDadosParaOHistorico(usuarioAtribuidor, processo.processo, descricao)
    return this.registrarNoHistorico(dadosParaOHistorico)
  }

  _criarDescricaoDoUsuarioAtribuido (nomeUsuario, numeroProcessso) {
    return `O processo ${numeroProcessso} foi atribuído com sucesso para ${nomeUsuario}.`
  }

  _criarDescricaoParaDesatribuicao (usuarioAtribuidor, processo) {
    return `O processo ${processo.processo} foi desatribuído com sucesso de ${processo.participanteAtual.titulo}`
  }

  _montarDadosParaOHistorico (atribuidoPor, numeroProcesso, descricao) {
    const instanciador = criarInstanciador(atribuidoPor)
    return {
      usuario: { ...instanciador, nome: instanciador.titulo },
      descricao: descricao,
      numeroProcesso
    }
  }

  registrarNoHistorico (dadosParaOHistorico) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/historico', dadosParaOHistorico)
        .then(response => resolve(response.data))
        .catch(error => {
          if (_usuarioNaoAutorizado(error)) {
            return reject(error)
          }
          http.post('/d0593/pae-back/v1/historico', dadosParaOHistorico)
            .then(response => resolve(response.data))
        })
    })
  }

  async atribuirProcessos (processo, dadosSessao) {
    var dados = atribuir(processo, dadosSessao)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados/atividades', { ...dados }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados/atividades', { ...dados }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desatribuirProcessos (processo, dadosSessao) {
    var dados = desatribuir(processo, dadosSessao)
    return new Promise((resolve, reject) => {
      http.put('/d0593/pae-back/v1/tramitados/atividades', { ...dados }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.put('/d0593/pae-back/v1/tramitados/atividades', { ...dados }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarVolumesDoProcesso (numeroProcesso) {
    var url = `/d0593/pae-back/v1/protocolos/${numeroProcesso}/atributos`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async inserirNovoVolume (numeroProcesso, dadosSessao) {
    var novoVolume = volume(numeroProcesso, dadosSessao)
    var url = `/d0593/pae-back/v1/protocolos/${numeroProcesso}/volumes`
    return new Promise((resolve, reject) => {
      http.post(url, novoVolume).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post(url, novoVolume).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async excluirVolume (numeroProcesso) {
    var url = `/d0593/pae-back/v1/protocolos/${numeroProcesso}/volumes`
    return new Promise((resolve, reject) => {
      http.delete(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.delete(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async consultaGeral (filtro) {
    return new Promise((resolve, reject) => {
      http.get('/d0593/pae-back/v1/protocolos', { params: { ...filtro } }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get('/d0593/pae-back/v1/protocolos', { params: { ...filtro } }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async buscarProtocoloExterno (numeroProcesso, dataCriacao) {
    return new Promise((resolve, reject) => {
      http.get(`/d0593/pae-back/v1/protocolos/externo/${numeroProcesso}`, { params: { dataCriacao } }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(`/d0593/pae-back/v1/protocolos/externo/${numeroProcesso}`, { params: { dataCriacao } }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async existeDocumentoExterno (numeroProcesso) {
    var url = `/d0593/pae-back/v1/protocolos/${numeroProcesso}/documentos/externo/has`
    return new Promise((resolve, reject) => {
      http.get(url).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async documentoExterno (numeroProcesso, login) {
    var params = {
      numeroProcesso,
      'autor.identificador': login
    }
    var url = `/d0593/pae-back/v1/protocolos/${numeroProcesso}/documentos/rascunho`
    return new Promise((resolve, reject) => {
      http.get(url, { params }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url, { params }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async armazenar (armazenamento) {
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados/setor/armazenamento', armazenamento).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados/setor/armazenamento', armazenamento).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async desarmazenar (numeroProcesso, sessao) {
    var url = `/d0593/pae-back/v1/tramitados/${numeroProcesso}/setor/armazenamento`
    return new Promise((resolve, reject) => {
      http.delete(url, {
        data: criarFinalizador(sessao, true)
      }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.delete(url).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async getInstanciaProtocolo (filtro) {
    var url = '/d0593/pae-back/v1/protocolos/setor/parent'
    return new Promise((resolve, reject) => {
      http.get(url, { params: { ...filtro } }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(url, { params: { ...filtro } }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async getInstanciaFluxoByNumeroProcesso (numeroProcesso) {
    return new Promise((resolve, reject) => {
      http.get(`/d0593/pae-back/v1/atividades/${numeroProcesso}`).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (_usuarioNaoAutorizado(err)) {
          return reject(err)
        }

        http.get(`/d0593/pae-back/v1/atividades/${numeroProcesso}`).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }

  async resgatarProtocolo (instanciaFluxo, dadosSessao) {
    var tramite = resgatarProtocolo(instanciaFluxo, dadosSessao)
    return new Promise((resolve, reject) => {
      http.post('/d0593/pae-back/v1/tramitados/resgatar', { ...tramite }).then((response) => {
        return resolve(response.data)
      }).catch(err => {
        if (err.response.status !== 401 || err.response.data.status === 'Perfil com acesso negado!') {
          return reject(err)
        }

        http.post('/d0593/pae-back/v1/tramitados/resgatar', { ...tramite }).then((response) => {
          return resolve(response.data)
        }).catch(() => {
          return reject(err)
        })
      })
    })
  }
}
